import { render, staticRenderFns } from "./HistoryRemuneration.vue?vue&type=template&id=53144a56&scoped=true"
import script from "./HistoryRemuneration.vue?vue&type=script&lang=js"
export * from "./HistoryRemuneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53144a56",
  null
  
)

export default component.exports